import { Helmet } from 'react-helmet';

const SITE = 'https://marja.ai';

// Mirrors PAGES in app.py, which injects these server-side for crawlers.
export const PAGES = {
  home: {
    path: '/',
    title: 'Marja AI | Ask Shia Islamic Law, Get Answers With Sources',
    description:
      "Ask Shia Islamic law questions and get answers that quote your Marja's published rulings, with links to the original text. Starting with Ayatollah Sistani.",
  },
  ask: {
    path: '/ask',
    title: 'Ask a Question | Marja AI',
    description:
      "Ask a question about Shia Islamic law and get an answer that quotes Ayatollah Sistani's published rulings, with links to the original sources.",
  },
  about: {
    path: '/about',
    title: 'About Marja AI | Made by Shias, for Shias',
    description:
      'Marja AI is built by believers to make Shia Islamic rulings easier to reach.',
  },
};

export const PageHead: React.FC<{
  page: (typeof PAGES)[keyof typeof PAGES];
}> = ({ page }) => {
  const url = SITE + page.path;
  return (
    <Helmet>
      <title>{page.title}</title>
      <meta name="description" content={page.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description} />
    </Helmet>
  );
};

export const ChatboxHeaders = () => <PageHead page={PAGES.ask} />;

export const NotFoundHead = () => (
  <Helmet>
    <title>Page not found | Marja AI</title>
    <meta name="robots" content="noindex" />
  </Helmet>
);
